import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

const SortableCell = ({ id, text }) => {
  const { attributes, listeners, transform, transition, setNodeRef } =
    useSortable({ id })

  const style = {
    cursor: 'grab',
    transform: CSS.Transform.toString(transform),
    transition
  }

  return (
    <span ref={setNodeRef} style={style} {...attributes} {...listeners}>
      ⠿ {text}
    </span>
  )
}

export default SortableCell
